import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BookAppointmentService } from '../book-appointment.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatError, MatHint } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { AppService } from 'src/app/services/app.service';
import { DepartmentDto, MakeDto } from 'src/app/services/client.service';
import '@angular/localize/init';

@Component({
  selector: 'app-vehicle-info',
  templateUrl: './vehicle-info.component.html',
  styleUrl: './vehicle-info.component.scss',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    NgClass,
    MatLabel,
    MatSelect,
    MatOption,
    MatError,
    MatInput,
    MatHint
  ]
})
export class VehicleInfoComponent implements OnInit, AfterViewInit {
  @Input() departments: DepartmentDto[] = [];
  @Input() makes: MakeDto[] = [];

  vehicleInfoForm!: FormGroup;
  selectvehicleType = $localize`Enter vehicle type`;
  selectMake = $localize`Enter vehicle make`;
  licenseNumberHint = $localize`Enter License number`;
  vinHint = $localize`Enter Vehicle Identification Number`;
  outletNotSupportedMessage = $localize`Online Appointment Booking not supported for this outlet`;
  contactDealerMessage = $localize`Please contact dealer directly.`;


  validationMessages: any = {
    make: { required: $localize`Select a vehicle make` },
    type: { required: $localize`Select a vehicle type` },
    licenseNo: { required: $localize`Enter vehicle license number`,
   maxlength: $localize`License No cannot exceed 15 characters.` },
    vin: { maxlength: $localize`VIN cannot exceed 17 characters.` }
  };

  constructor(
    private fb: FormBuilder,
    private bookAppointmentService: BookAppointmentService,
    private sessionStorageService: SessionStorageService,
    public dialog: MatDialog,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.vehicleInfoForm = this.fb.group({
      make: ['', [Validators.required]],
      type: ['', [Validators.required]],
      licenseNo: ['', [Validators.required, Validators.maxLength(15)]],
      vin: ['', [Validators.maxLength(17)]]
    });

    this.vehicleInfoForm.valueChanges.subscribe(() => {
      this.bookAppointmentService.updateVehicleInfoStatus(this.vehicleInfoForm.valid);
      const sessionDataString = this.sessionStorageService.getSessionItem('oabAppSessionData');
      const sessionData = sessionDataString ? JSON.parse(sessionDataString) : null;

      const vehicleInfo = this.vehicleInfoForm.value;
      const vehicleInfoObject = sessionData
        ? {
          dealership: sessionData.dealership,
          vehicleInfo,
          appointment: sessionData.appointment,
          customerInfo: sessionData.customerInfo
        }
        : { vehicleInfo };

      this.sessionStorageService.setSessionItem('oabAppSessionData', JSON.stringify(vehicleInfoObject));

    });

    this.getDepartments();
    this.getMakes();
  }

  ngAfterViewInit(): void {
    const sessionDataString = this.sessionStorageService.getSessionItem('oabAppSessionData');
    const sessionData = sessionDataString ? JSON.parse(sessionDataString) : null;

    if (sessionData && sessionData.vehicleInfo) {
      setTimeout(() => {
        this.vehicleInfoForm.patchValue(sessionData.vehicleInfo);
      });
    }
  }

  getDepartments() {
    this.appService.getDepartments().subscribe({
      next: (response: DepartmentDto[]) => {
        if (!response || response.length === 0) {
          this.departments = [];
          this.showOutletNotSupportedMessage();
          return;
        }
        this.departments = response;
      },
      error: (err) => {
        this.departments = [];
        if (
          err?.error?.detail?.includes("authorization") ||
          err?.detail?.includes("authorization")
        ) {
          this.appService.handleErrorMessage(err);
        }
        else {
          this.showOutletNotSupportedMessage();
        }
      }
    });
  }

  getMakes() {
    this.appService.getMakes().subscribe({
      next: (response: MakeDto[]) => {
        if (!response || response.length === 0) {
          this.makes = [];
          this.showOutletNotSupportedMessage();
          return;
        }
        this.makes = response;
      },
      error: (err) => {
        this.makes = [];

        if (
          err?.error?.detail?.includes("authorization") ||
          err?.detail?.includes("authorization")
        ) {
          this.appService.handleErrorMessage(err);
        } else {
          this.showOutletNotSupportedMessage();
        }
      }
    });
  }

  private showOutletNotSupportedMessage() {
    const sessionDataString = this.sessionStorageService.getSessionItem('oabAppSessionData');
    const sessionData = sessionDataString ? JSON.parse(sessionDataString) : null;
    const dealerName = sessionData?.dealership?.Name;

    const message = `${this.outletNotSupportedMessage} (${dealerName}). ${this.contactDealerMessage}`;
    this.appService.handleErrorMessage(message);
  }

}
